import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionCtl } from 'lib-klab-core';

export const authGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const sessionCtl = inject(SessionCtl);

  if (sessionCtl.loggedInCheckSync()) return true;

  return router.createUrlTree(['/login'], {
    queryParams: { redirect: state.url },
  });
};